import axios from "axios";

export const state = {
    staffmembers: [],
};

export const getters = {
    staffmembers: state => state.staffmembers,
};

export const mutations = {
    setStaffMembers(state, newValue) {
        state.staffmembers = newValue
    },
};

export const actions = {
    fetchStaffMembers({ commit }) {
        axios.get('/staffmembers').then(res => {
            commit('setStaffMembers', res.data.staffmembers);
        })
    },
};